<template>
  <div class="container">
    <div class="row">
      <h2 class="mb-3">Reporte de confecciones</h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-5 mb-4">
        <div v-if="isLoading" style="padding: 5ch 0;">
          <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
        </div>
        <template v-else>
          <form @submit.prevent="sendRequest" class="card p-4 filters-form">
            <div class="row mb-3">
              <div class="col">
                <label class="form-label">Fecha inicio:</label>
                <input type="date" v-model="filterParamsData.dateStart" required class="form-control">
              </div>
              <div class="col">
                <label class="form-label">Fecha fin:</label>
                <input type="date" v-model="filterParamsData.dateEnd" required class="form-control">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <label class="form-label" for="reference-ids">Confecciones:</label>
                <select name="reference-ids" id="reference-ids" v-chosen="selectedReferenceIds"
                  v-model="selectedReferenceIds" multiple class="form-control">
                  <option value="" selected disabled hidden></option>
                  <option v-for="r in references" :key="r.id" :value="r.id">{{ r.code }} - {{ r.descrip }}</option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <label class="form-label" for="shift-individual">Turno (opcional):</label>
                <select name="shift-individual" id="shift-individual" v-chosen="selectedShiftsIndividualId"
                  v-model="selectedShiftsIndividualId" class="form-select">
                  <option :value=-1 selected disabled hidden></option>
                  <option v-for="(sI, index) in shiftsIndividuals" :value="index">{{ sI.start_time
                  }} - {{ sI.end_time }}</option>
                </select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <label class="form-label" for="production-line-ids">Líneas de producción (opcional):</label>
                <select name="production-line-ids" id="production-line-ids" v-chosen="selectedProductionLineIds"
                  v-model="selectedProductionLineIds" multiple class="form-control">
                  <option value="" selected disabled hidden></option>
                  <option v-for="pL in productionLines" :key="pL.id" :value="pL.id">{{ pL.code }}</option>
                </select>
              </div>
            </div>
            <div class="form-check form-switch mb-3">
              <input type="checkbox" v-model="filterParamsData.skipDaysWithNoShifts" class="form-check-input"
                id="skipDaysWithNoShifts">
              <label class="form-check-label" for="skipDaysWithNoShifts">Omitir días sin turnos</label>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <button type="button" class="btn btn-primary w-100 mb-3" @click="saveFiltersToCookies">
                  Guardar filtros
                </button>
              </div>
              <div class="col-sm-12 col-md-6">
                <button type="button" class="btn btn-danger w-100 mb-3" @click="clearFiltersFromCookies">
                  Borrar filtros
                </button>
              </div>
            </div>
            <button type="submit" class="btn btn-primary w-100 custom-green-button" :disabled="isLoadingData">
              Enviar
            </button>
          </form>
        </template>
      </div>
      <div class="col-md-12 col-lg-7 mb-4">
        <div class="card p-3">
          <div class="dflex">
            <button class="btn btn-secondary custom-green-button mb-2 w-100" @click="toggleSummedData">
              Cambiar a datos {{ showSummedData ? 'de radar' : 'confecciones' }}
            </button>
          </div>
          <template v-if="showSummedData">
            <div class="mb-2 d-flex flex-wrap gap-2 justify-content-center"
              v-if="Object.keys(referencesData).length > 0">
              <button class="btn btn-info custom-green-pie-button"
                :class="{ 'selected-custom-green-pie-button': selectedProductionLineForSummedData == null }"
                @click="handleLineDataClick(summedData, null)">
                Ver detalles de todas las confecciones
              </button>
              <div v-for="(referenceData, index) in referencesData" :key="index">
                <button class="btn btn-info custom-green-pie-button"
                  :class="{ 'selected-custom-green-pie-button': selectedProductionLineForSummedData == index }"
                  @click="handleLineDataClick(referenceData.summedData, index)">
                  Ver detalles de {{ referenceData.name || `Confección ${index + 1}` }}
                </button>
              </div>
            </div>
            <ConfectionProductionReportingSummedData :summedData="summedDataToShow" :isLoadingData="isLoadingData" />
          </template>
          <template v-else>
            <ConfectionProductionReportingRadarGraphicDataContainer :referencesData="referencesData"
              :isLoadingData="isLoadingData" />
          </template>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col mb-4">
        <div class="card p-4">
          <ConfectionProductionReportingSectionsGraphicDataContainer :referencesData="referencesData"
            :isLoadingData="isLoadingData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import ConfectionProductionReportingSummedData from '../components/ConfectionProductionReportingSummedData.vue';
import ConfectionProductionReportingSectionsGraphicDataContainer from '../components/ConfectionProductionReportingSectionsGraphicDataContainer.vue';
import ConfectionProductionReportingRadarGraphicDataContainer from '../components/ConfectionProductionReportingRadarGraphicDataContainer.vue';
export default {
  name: 'ConfectionProductionReporting',
  components: {
    SpeenComponent,
    ConfectionProductionReportingSummedData,
    ConfectionProductionReportingSectionsGraphicDataContainer,
    ConfectionProductionReportingRadarGraphicDataContainer,
  },
  data() {
    return {
      filterParamsData: {
        dateStart: new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 1)).toISOString().split('T')[0],
        dateEnd: new Date(new Date().setDate(new Date().getDate())).toISOString().split('T')[0],
        skipDaysWithNoShifts: true,
      },
      selectedShiftsIndividualId: -1,
      selectedProductionLineIds: [],
      selectedReferenceIds: [],
      productionLines: [],
      shiftsIndividuals: [],
      references: [],
      isLoading: true,
      summedData: {},
      referencesData: {},
      summedDataToShow: {},
      selectedProductionLineForSummedData: null,
      isLoadingData: false,
      showSummedData: true,
    };
  },
  methods: {
    sendRequest() {
      let params = {
        date_start: this.filterParamsData.dateStart,
        date_end: this.filterParamsData.dateEnd,
        skip_days_with_no_shifts: this.filterParamsData.skipDaysWithNoShifts,
      };
      if (this.selectedShiftsIndividualId != -1 && this.selectedShiftsIndividualId != null) {
        params.time_start = this.shiftsIndividuals[this.selectedShiftsIndividualId].start_time;
        params.time_end = this.shiftsIndividuals[this.selectedShiftsIndividualId].end_time;
      }
      if (this.selectedProductionLineIds.length > 0) params.productionLineIds = this.selectedProductionLineIds;
      if (this.selectedReferenceIds.length > 0) params.referenceIds = this.selectedReferenceIds;

      this.isLoadingData = true;
      axios.get('/api/confection-reporting/get-data-by-date', { params })
        .then(response => {
          this.summedData = response.data.summedData;
          this.referencesData = response.data.referencesData;
          this.handleSummedDataToShow();       
          showCustomSuccessSweetAlert('Datos obtenidos correctamente');
        })
        .catch(error => {
          console.error('Error al obtener los datos:', error);
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    startingData() {
      axios.get('/api/confection-reporting/get-filters-data')
        .then(response => {
          this.productionLines = response.data.productionLines;
          this.shiftsIndividuals = response.data.shiftsIndividuals;
          this.references = response.data.references;
        })
        .catch(error => {
          console.error('Error al obtener los datos de inicio:', error);
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    toggleSummedData() {
      this.showSummedData = !this.showSummedData;
    },
    saveFiltersToCookies() {
      const filters = {
        dateStart: this.filterParamsData.dateStart,
        dateEnd: this.filterParamsData.dateEnd,
        skipDaysWithNoShifts: this.filterParamsData.skipDaysWithNoShifts,
        selectedShiftsIndividualId: this.selectedShiftsIndividualId,
        selectedProductionLineIds: this.selectedProductionLineIds,
        selectedReferenceIds: this.selectedReferenceIds,
      };
      CookieUtils.setCookie('confectionProductionReportingFilters', JSON.stringify(filters), 86400);
      showCustomSuccessSweetAlert('Filtros guardados correctamente');
    },
    clearFiltersFromCookies() {
      CookieUtils.deleteCookie('confectionProductionReportingFilters');
      this.applyBaseStartingData();
      showCustomSuccessSweetAlert('Filtros borrados correctamente');
    },
    applyStartingDataFromCookies() {
      const filters = CookieUtils.getCookie('confectionProductionReportingFilters');
      if (filters) {
        const parsedFilters = JSON.parse(filters);
        this.filterParamsData.dateStart = parsedFilters.dateStart;
        this.filterParamsData.dateEnd = parsedFilters.dateEnd;
        this.filterParamsData.skipDaysWithNoShifts = parsedFilters.skipDaysWithNoShifts;
        if (parsedFilters.selectedShiftsIndividualId != -1) {
          this.selectedShiftsIndividualId = parsedFilters.selectedShiftsIndividualId;
        }
        if (parsedFilters.selectedProductionLineIds && parsedFilters.selectedProductionLineIds.length > 0) {
          this.selectedProductionLineIds = parsedFilters.selectedProductionLineIds;
        }
        if (parsedFilters.selectedReferenceIds && parsedFilters.selectedReferenceIds.length > 0) {
          this.selectedReferenceIds = parsedFilters.selectedReferenceIds;
        }
      }
    },
    applyBaseStartingData() {
      this.isLoading = true;
      this.filterParamsData.dateStart = new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 1)).toISOString().split('T')[0];
      this.filterParamsData.dateEnd = new Date(new Date().setDate(new Date().getDate())).toISOString().split('T')[0];
      this.filterParamsData.skipDaysWithNoShifts = true;
      this.selectedShiftsIndividualId = -1;
      this.selectedProductionLineIds = [];
      this.selectedReferenceIds = [];
      setTimeout(() => {
        this.isLoading = false;
      }, 200);
    },
    handleLineDataClick(lineSummedData, index) {
      this.selectedProductionLineForSummedData = index;
      this.summedDataToShow = lineSummedData;
    },
    handleSummedDataToShow() {
      let summedDataToShow = this.summedData;
      if (this.referencesData && this.referencesData[this.selectedProductionLineForSummedData]) summedDataToShow = this.referencesData[this.selectedProductionLineForSummedData].summedData;
      else this.selectedProductionLineForSummedData = null;
      this.summedDataToShow = summedDataToShow;
    }
  },
  mounted() {
    this.applyStartingDataFromCookies();
    this.startingData();
  }
};
</script>
